"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const icons_1 = require("../icons");
const Avatar = ({ avatar }) => {
    return (react_1.default.createElement("div", { className: "w-9 h-9 bg-gray-100 border border-solid border-gray-200 dark:border-gray-600 rounded-full overflow-hidden" }, avatar ? (react_1.default.createElement("img", { className: "inline-block w-9 h-9 object-cover", src: avatar, alt: "avatar" })) : (react_1.default.createElement(icons_1.AvatarIcon, { className: 'block p-1 w-9 h-9 text-gray-300' }))));
};
exports.default = Avatar;
